import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const EventPackagesSearch = loadable(() => import('./EventPackagesSearch'));

EventPackagesSearch.getInitialState = getInitialState;

export default EventPackagesSearch;
